export interface Pill {
  title: string;
  color: string;
}
